 
const SpecialTab = (props: any) :JSX.Element => {
  return (
    <div>SpecialTab</div>
  )
}
 
export default SpecialTab